export default "__VITE_ASSET__7c67443a__"